import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=5049bb98&scoped=true&"
import script from "./ProductInfo.vue?vue&type=script&lang=js&"
export * from "./ProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=5049bb98&prod&scoped=true&lang=css&"
import style1 from "./ProductInfo.vue?vue&type=style&index=1&id=5049bb98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049bb98",
  null
  
)

export default component.exports